import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  root: {
    position: "relative",
    height: "100%",
    minHeight: 300,
  },
  mapContainer: {
    width: "100%",
    height: "100%",
  },
  searchBox: {
    position: "absolute",
    zIndex: 50,
    top: theme.hv.spacing.xs,
    left: theme.hv.spacing.xs,
    "& .HvBaseInput-inputRoot": {
      height: "32px",
      background: "#FBFCFC 0% 0% no-repeat padding-box",
      "& .HvInput-adornmentsBox": {
        opacity: 0.5,
      },
    },
    "& .HvBaseInput-inputRootFocused": {
      background: "#FBFCFC",
    },
  },

  markerContainer: {
    "& p": {
      color: "white",
      fontSize: 13,
    },

    width: 40,
    height: 50,
  },

  marker: {
    textAlign: "center",
    width: 32,
    height: 32,
    margin: 5,
  },
  markerShadow: {
    boxShadow: "-1px 1px 4px rgba(0, 0, 0, .5)",
  },
  markerBox: {
    "&>svg, &>div.fa": {
      fontSize: 17,
      marginTop: "23%",
    },
    "&>img": {
      marginTop: "25%",
    },
  },
  markerCircle: {
    borderRadius: "50% 50% 50% 0",
    transform: "rotate(-45deg)",

    "&>svg, &>div.fa": {
      fontSize: 17,
      marginTop: "23%",
      transform: "rotate(45deg)",
    },
    "&>img": {
      marginTop: "25%",
      transform: "rotate(45deg) rotateX(-20deg)",
    },
  },
  markerPointer: {
    width: 0,
    height: 0,
    border: "solid transparent",
    borderWidth: 7,
    transform: "translate(14px, -5px)",
  },
}));

export default styles;

export const googleMapStyles: L.gridLayer.GoogleMutantStyle[] = [
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#d3d3d3",
      },
    ],
  },
  {
    featureType: "transit",
    stylers: [
      {
        color: "#808080",
      },
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#b3b3b3",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffffff",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#ffffff",
      },
      {
        weight: 1.8,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#d7d7d7",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#ebebeb",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [
      {
        color: "#a7a7a7",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffffff",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffffff",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#efefef",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#696969",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#737373",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#d6d6d6",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {},
  {
    featureType: "poi",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#dadada",
      },
    ],
  },
];
